export const blogData = [
    {
        id: 1,
        title: 'Smart India Hackathon',
        date: 'Dec 2023',
        image: './sih.jpg',
        url: 'https://drive.google.com/file/d/1e09tTNqoeOMv3pufHBaSkJg5zdSTlO30/view?usp=drive_link'
    },
    {
        id: 2,
        title: 'ReGen Hackathon (NIT Manipur)',
        date: 'Mar 2025',
        image: './BLUELOCK.jpg',
        url: 'https://drive.google.com/file/d/1exeAqWJhb8tVX-Vk9LV8I0WJ2amoBiDY/view?usp=drive_link'
    },
    {
        id: 3,
        title: 'Competitive Programming (IIIT Manipur)',
        date: 'April 2024',
        image: './cpIIIT.jpg',
        url: 'https://drive.google.com/file/d/11YocDjyUIX9HsonG7dgjV3Hm8H6uEFTS/view?usp=drive_link'
    },
    {
        id: 4,
        title: 'Trek-a-thon Guwahati',
        date: 'Jan 2025',
        image: './Trek-a-thon.jpg',
        url: 'https://drive.google.com/file/d/1n4g9HbTd78BhYRJ29qOIkeBB9NFYECo_/view?usp=drive_link'
    },
    {
        id: 5,
        title: 'Hackathon (IIIT Manipur)',
        date: 'April 2024',
        image: './Hackathon.jpg',
        url: 'https://drive.google.com/file/d/11JlFg0YDTOCkEtCJgIlkTbDKUz2erlFS/view?usp=drive_link'
    },
    {
        id: 6,
        title: 'Web Development, Apna College',
        date: 'Jan 2024',
        image: './apnaCollege.png',
        url: 'https://drive.google.com/file/d/1GF62lr-pjhS-L1g1gHzc6yJFrkZxCbGK/view?usp=drive_link'
    },
    {
        id: 7,
        title: 'Artificial Intelligence, Rinex',
        date: 'May 2023',
        image: './ai.png',
        url: 'https://drive.google.com/file/d/1kvTOlCJRO1tlThHiqwOuQEtqNmcXx_OW/view?usp=drive_link'
    },
    {
        id: 8,
        title: 'Flipkart Grid 2025',
        date: 'July 2025',
        image: './flipkart.png',
        url: 'https://drive.google.com/file/d/1dEMPa42MAnnrvRAa1R_4z2OSTvlpABlX/view?usp=drive_link'
    },
    {
        id: 9,
        title: 'Physics Wallah Internship',
        date: 'Dec 2024',
        image: './physics.png',
        url: 'https://drive.google.com/file/d/1noQpTI_cMi7-13n4nZ1NJ3MunGkhaddT/view?usp=drive_link'
    },
    {
        id: 10,
        title: 'Future Netwings Internship',
        date: 'June 2023',
        image: './future.png',
        url: 'https://drive.google.com/file/d/1MsStou-BDYVLn9-Anzg0CJvfzwV8nz0i/view?usp=drive_link'
    },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/